import React from "react";
import styled from "styled-components";
import { Modal, ModalBody } from "reactstrap";
import Button from "../button";
import colors from "../../design/colors";
import fonts from "../../design/typography";

/* **********************************
 * TYPES
 ********************************** */
interface AlertModalProps {
  isOpen: boolean;
  message: string;
  confirmText?: string;
  onConfirm: () => void;
  onClose: () => void;
  width?: string;
  buttonColor?: string;
  textColor?: string;
  fontStyle?: React.CSSProperties;
}

/* **********************************
 * COMPONENT
 ********************************** */
const AlertModal = ({
  isOpen,
  message,
  confirmText = "확인",
  onConfirm,
  onClose,
  width,
  buttonColor = colors.blue600,
  textColor = colors.gray50,
  fontStyle,
}: AlertModalProps) => {
  return (
    <StyledModal
      isOpen={isOpen}
      toggle={onClose}
      contentClassName="custom-modal-content"
      width={width}
    >
      <ModalBody style={{ padding: "24px", width: width }}>
        <div
          style={{
            ...fonts.body2Medium,
            color: colors.gray900,
            textAlign: "center",
            margin: "24px 0 32px 0",
          }}
        >
          {message}
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            size="medium"
            width="112px"
            height="40px"
            text={confirmText}
            onClick={onConfirm}
            buttonColor={buttonColor}
            textColor={textColor}
            style={fontStyle}
          />
        </div>
      </ModalBody>
    </StyledModal>
  );
};

export default AlertModal;

/* **********************************
 * Styles
 ********************************** */
const StyledModal = styled(Modal)<{ width?: string }>`
  z-index: 99999 !important;

  .modal-dialog {
    max-width: ${(props) => props.width ?? "300px"};
    width: ${(props) => props.width ?? "300px"};
    z-index: 99999 !important;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .modal-content {
    z-index: 99999;
    max-width: ${(props) => props.width ?? "300px"};
    width: ${(props) => props.width ?? "300px"};
    position: relative;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
  }

  .modal-backdrop.show {
    z-index: 99998 !important;
  }
`;
